import { Component, Input } from '@angular/core';
import { DetailsSkeletonComponent } from './details-skeleton/details-skeleton.component';
import { DecimalPipe } from '@angular/common';
import { HasReferencesPipe } from '../../pipes/has-references.pipe';
import { Shipment } from '../../../../pages/overview/models/shipment';
import { CourierTrackingLinksPipe } from '../../pipes/courier-tracking-links.pipe';

@Component({
  selector: 'app-details',
  standalone: true,
  templateUrl: './details.component.html',
  imports: [DetailsSkeletonComponent, DecimalPipe, HasReferencesPipe, CourierTrackingLinksPipe],
  styleUrl: './details.component.scss'
})
export class DetailsComponent {
  @Input() shipment: Shipment | null = null;
}
